
import { useEffect, useState } from 'react';
import { Routes, Route, Link , useNavigate, Outlet} from 'react-router-dom'
import {Row, Col, Container} from 'react-bootstrap';

function Footer()
{
    return (
        <>
        <div id='footer'>
            <div className='center'>
                <div className='foot_menu_d1 cs'>
                    <p className='title'>CS CENTER</p>
                    <h3>1661-1188</h3>
                    <ul>
                        <li>평일 09:00 -18:00</li>
                        <li>점심 12:00 - 13:00</li>
                        <li>주말 공휴일 휴무</li>
                    </ul>
                </div>
                <div className='foot_menu_d1 bank'>
                    <p className='title'>BANK INFO</p>
                    <h3>수협 000-00-000000</h3>
                    <ul>
                        <li>예금주 : (주)목포해와</li>
                    </ul>
                </div>

                <div className='foot_menu_d1 sns'>
                    <p className='title'>SNS</p>
                   
                </div>
            </div>

            <div className='black'>
                <div className='inner'>
                    <ul>
                        <li>
                            <a>회사소개</a>
                        </li>
                        <li>
                            <a>입점 및 판매자센터</a>
                        </li>
                        <li>
                            <a>이용약관</a>
                        </li>
                        <li>
                            <a>이용안내</a>
                        </li>
                        <li>
                            <a>개인정보처리방침</a>
                        </li>
                    </ul>
                </div>
            </div>

            <div className='bottom'>
                <div className='inner'>
                    <div className='layout-footer'>
                        <ul className='menu3'>
                            <li>
                                <span>회사명 : </span>
                                <span>(주)목포해와</span>
                            </li>
                            <li>
                                <span>대표자 : </span>
                                <span>박태웅</span>
                            </li>
                            <li>
                                <span>주소 : </span>
                                <span>전라남도 목포시 해안동2가 7-2</span>
                            </li>
                            <li>
                                <span>전화 : </span>
                                <span>010-8542-5479</span>
                            </li>
                            <li>
                                <span>팩스 : </span>
                                <span>0504-496-8706</span>
                            </li>
                            <li>
                                <span>사업자등록번호 : </span>
                                <span>
                                    703-88-02503 
                                    <a href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=7038802503" target="_blank">[사업자정보확인]</a>
                                </span>
                            </li>
                            <li>
                                <span>통신판매중개업신고번호 : </span>
                                <span>제2023-전남목포-0240호</span>
                            </li>
                            <li>
                                <span>개인정보보호책임자 : </span>
                                <span>박태웅</span>
                            </li>
                            <li>
                                <span>호스팅 제공자 : </span>
                                <span>Amazon Web Service</span>
                            </li>
                        </ul>

                    </div>
                </div>
            </div>
        </div>
        <div className="fs-7 text-center p-2">
            목포해와는 통신판매중개자이며 상품, 상품정보, 거래의무, 책임은 판매자에게 있습니다.
        </div>
        </>
    )

}

const Footer2 = () => {
    const navigate = useNavigate();

    const [showPopup, setShowPopup] = useState(false);
    const handleShowPopup = () => {
        setShowPopup(true);
    }
    const handleClosePopup = () => {
        setShowPopup(false);
    }

    return(
        <>
        <div className='bg-dark p-3'>
            <Container className='text-white'>
                <Row className='align-items-center ps-3 pe-3 mb-2'>
                    <Col xs={12} md={3} className="fs-4 fw-bold mt-3 p-0 text-center text-sm-start">(주)목포해와</Col>
                    <Col xs={12} md={9} className='order-first order-md-last mt-3'>
                        <>
                            <Row xs="auto justify-content-center justify-content-md-end">
                                <Col className='p-0 ps-2 pe-2 pointer' onClick={()=>navigate('/selleradmin/login')}>입점 및 판매자센터</Col>
                                <Col className='p-0 ps-2 pe-2 pointer' onClick={()=>navigate('/customer/refunds')}>교환환불정책</Col>
                                <Col className='p-0 ps-2 pe-2 pointer' onClick={()=>navigate('/customer/conditions')}>이용약관</Col>
                                <Col className='p-0 ps-2 pe-2 pointer' onClick={()=>navigate('/customer/term')}>개인정보처리방침</Col>
                            </Row>
                        </>
                    </Col>
                </Row>
                <Row className='p-2 pt-3 fs-7 d-flex align-items-end'>
                    <Col xs={12} sm={7} className="mb-3 text-center text-sm-start">
                        <p><b>대표이사</b> : 박태웅</p>
                        <p><b>주소</b> : 전라남도 목포시 광동3가 6-1 목포 건어물 젓갈센터 205호</p>
                        <p><b>사업자등록번호</b> : 703-88-02503 <a href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=7038802503" target="_blank"><b>[사업자정보확인]</b></a></p>
                        <p><b>통신판매업 신고</b> : 제2023-전남목포-0240호</p>
                        <p><b>FAX</b> : 061-242-0999</p>
                        <p><b>이메일</b> : mokpo@daum.net</p>
                        <p><b>호스팅 제공자</b> : Amazon Web Serviece</p>
                    </Col>
                    <Col xs={12} sm={5} className="mb-3 text-center text-sm-end">
                        <p className='fs-3'><b>070-4249-0302</b></p>
                        <p className='fs-6'>오전 09:00 ~ 오후 06:00</p>
                        <p className='fs-6'>(토, 일, 공휴일 휴무)</p>
                    </Col>
                </Row>
                <Row className='p-4 fs-6'>
                    Copyright (c) 2023 MOKPOHAEWA INC. All rights reserved.
                </Row>
            </Container>
        </div>
        <Container className="text-center pt-2 pb-2 fs-7">
            목포해와는 통신판매중개자이며 상품, 상품정보, 거래의무, 책임은 판매자에게 있습니다.
        </Container>
        </>
    )
}

export default Footer2